import React from 'react';
import { Modal } from 'semantic-ui-react';
import {
    StandardizedLabelCreationSchemaType,
    StandardizedLabelType,
    StandardizedLabelUpdateSchemaType,
} from '../../../../../schemas/standardizedLabel.schemas';
import StandardizedLabelForm from '../standardizedLabelForm';

type StandardizedLabelModalPropsType = {
    open: boolean;
    standardizedLabel?: StandardizedLabelType;
    onCancel: () => void;
    onSave: (data: StandardizedLabelUpdateSchemaType | StandardizedLabelCreationSchemaType) => void;
};

function StandardizedLabelModal({ open, standardizedLabel, onSave, onCancel }: StandardizedLabelModalPropsType) {
    return (
        <Modal size="small" open={open} onClose={onCancel}>
            <Modal.Header>{standardizedLabel ? 'Update Standardized Label' : 'Create Standardized Label'}</Modal.Header>
            <Modal.Content>
                <StandardizedLabelForm standardizedLabel={standardizedLabel} onSave={onSave} onCancel={onCancel}/>
            </Modal.Content>
        </Modal>
    );
}

export default StandardizedLabelModal;
